module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [(_vm.options.includes('semester')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "date_range",
      "label": "Semestre",
      "single-line": "",
      "hide-details": "",
      "items": _vm.semesters,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filters.semester),
      callback: function($$v) {
        _vm.$set(_vm.filters, "semester", $$v)
      },
      expression: "filters.semester"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.includes('status')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "bookmark",
      "label": "Situação",
      "single-line": "",
      "hide-details": "",
      "items": _vm.statuses,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.includes('view')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "group_work",
      "label": "Filtro",
      "single-line": "",
      "hide-details": "",
      "items": _vm.viewItems
    },
    model: {
      value: (_vm.filters.view),
      callback: function($$v) {
        _vm.$set(_vm.filters, "view", $$v)
      },
      expression: "filters.view"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.includes('course')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm1": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "class",
      "label": "Curso",
      "single-line": "",
      "hide-details": "",
      "items": _vm.userCourses,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filters.course),
      callback: function($$v) {
        _vm.$set(_vm.filters, "course", $$v)
      },
      expression: "filters.course"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.includes('type')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "append-icon": "create",
      "label": "Tipo",
      "single-line": "",
      "hide-details": "",
      "items": _vm.userTypes,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filters.type),
      callback: function($$v) {
        _vm.$set(_vm.filters, "type", $$v)
      },
      expression: "filters.type"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.includes('enrolled')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "offset-sm6": ""
    }
  }, [(_vm.authenticated) ? _c('v-select', {
    attrs: {
      "append-icon": "assignment_turned_in",
      "label": "Inscrição",
      "single-line": "",
      "hide-details": "",
      "items": _vm.enrolledItems,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.filters.enrolled),
      callback: function($$v) {
        _vm.$set(_vm.filters, "enrolled", $$v)
      },
      expression: "filters.enrolled"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7834c0f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamFilters.vue
// module id = 255
// module chunks = 0